import { render } from "./AdminNav.vue?vue&type=template&id=315ed71a&scoped=true"
import script from "./AdminNav.vue?vue&type=script&lang=js"
export * from "./AdminNav.vue?vue&type=script&lang=js"

import "./AdminNav.vue?vue&type=style&index=0&id=315ed71a&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/www/releases/20260911022759/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-315ed71a"]])

export default __exports__